var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t(
              "CargoMsg.Cargo_PleaseSelectTheManifestYouWishToDelete"
            ),
            width: "600px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.manifestGoods,
                "tooltip-effect": "dark",
                height: "300px",
                "row-key": "uuid",
                "span-method": _vm.spanMethod
              },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "soNo",
                  label: _vm.$t("CargoMsg.Cargo_BLNo"),
                  width: "220"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.soNo))])]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "containerNo",
                  label: _vm.$t("CargoMsg.Cargo_ContainerNo"),
                  width: "220"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.containerNo))])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("br"),
          _c("br"),
          _vm.isRongeTong
            ? _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Message.ReasonForDeletion"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "custom-textarea",
                        staticStyle: { width: "70%" },
                        attrs: { rows: 4, type: "textarea" },
                        model: {
                          value: _vm.reason,
                          callback: function($$v) {
                            _vm.reason = $$v
                          },
                          expression: "reason"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("div", [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("CargoMsg.Cargo_TheManifestYouWishToDeleteTips"))
              )
            ])
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.confirmDelete }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmDelete")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }